import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'achievementMessage',
    standalone: false
})
export class AchievementMessagePipe implements PipeTransform {
  transform(achievementLevel: number): string {
    const messages = {
      0: 'There’s so much more to SalesIntel.',
      1: 'There’s so much more to SalesIntel.',
      2: 'You’ve made a lot of progress.',
      3: 'You’ve unlocked so much value with SalesIntel, but there’s still more available.',
      4: 'You’ve achieved so much!',
    };
    return messages[achievementLevel] || '';
  }
}
